var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.story.content.component,{tag:"component",attrs:{"blok":_vm.story.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }